import * as React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

interface IProps {
    show: boolean,
    existingXm: boolean,
    status: string,
    donorAlias: string,
    donorCenterAlias: string,
    onSend: () => void,
    onCancel: () => void
}

class RequestScreeningXm extends React.Component<IProps, {}> {
    handleSend = () => {
        this.props.onSend();
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        return (
            <Modal show={this.props.show} onHide={this.handleCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Request for Screening XM for {this.props.donorAlias} at {this.props.donorCenterAlias}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>Click the send button below if you are sure you wish to request the screening XM.</p>

                    {this.props.existingXm && (
                        <Alert bsStyle='warning' className='text-center'>
                            There is already an existing {this.props.status} screening XM for this donor.<br />
                            Are you sure you wish to request another?
                        </Alert>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.handleSend}>Send Screening XM Request</Button>
                    <Button onClick={this.handleCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default RequestScreeningXm;